export default __webpack_public_path__ + "static/media/eg.b1e40e59.svg";